<template>
  <section class="bd-b-1 bd-gray-300-brand py-24" v-if='dataTrip'>
    <h2 class="mb-16 heading-4-bd">Trip Overview</h2>
    <div class="description mb-16">
      <Readmore class="text-md-rg" :text="nl2br(dataTrip.overview)" :text-max="isMobile ? 60 : 100" heap="view-full-trip-plan-overview"/>
    </div>
    <template v-if="!isSimplified">
      <div class="flex flex-wrap mb-overflow-y-scroll" >
        <div
          class="bg-cream-deep tc py-4 px-8 br-999 mr-6 item flex items-center white-space mb-6"
          v-for="(item, index) in dataTrip.activity_types" :key="index"
        > 
          <img
            class="activity-icon"
            :src="`${$assetsCdn}/icons/activities/${item.name}.svg`"
            :alt="item.name"
          />
          <label class="text-md-sb mb-text-sm-sb db ml-6">{{
            item.name
          }}</label>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { inject, ref, } from 'vue'
import Readmore from '~/components/ui/readmore/readmoreHTML'
import { nl2br } from '~/helper'

export default {
  setup() {
    const {isMobile} = useDevice()
    const dataTrip = inject('dataTrip', ref({}))
    const isSimplified = inject('isSimplified', false)
    return {
      nl2br,
      dataTrip,
      isSimplified,
      isMobile,
    }
  },
  components: { Readmore },
}
</script>

<style lang="scss" scoped>
@include scroll-section();
.description {
  p:last-child {
    margin-bottom: 0;
  }
  
  & :deep(.readmore--html) {
      button {
        .underline {
          font-weight: 700;
        }
      }
  }
}

.item {
  flex: 0 0 120px;
  &:last-child {
    margin-right: 0 !important;
  }
  img {
    width: 32px;
    height: auto;
  }
  // Activity-type icons are dark-navy monochrome SVGs served <img>-loaded from the S3
  // static CDN (dynamic set keyed by item.name — can't be re-pointed at a repo -v2 asset).
  // Recolour them to $brand-green (#197660) with a solved filter chain: the
  // `brightness(0) saturate(100%)` prefix normalises the source to pure black, then the
  // chain tints to exactly rgb(25,118,96) — verified numerically (loss 0.037).
  .activity-icon {
    filter: brightness(0) saturate(100%) invert(81%) sepia(44%) saturate(3721%) hue-rotate(111deg) brightness(47%) contrast(80%);
  }
  // svg {
  //   width: 40px;
  //   height: 40px;
  // }
}
</style>
